/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on May 26, 2025 at 5:33 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 27, 2025 at 1:37 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const fetchFeed = ({
	page,
	limit,
	contentTypes,
	tags,
	sortBy,
	mediumTypes,
	displayedSupportIds,
	messageTypes
} = {}) => api.post(`${PARSE_MOUNT}/functions/fetchFeed`, {
	page,
	limit,
	tags,
	sort_by: sortBy,
	content_types: contentTypes,
	medium_types: mediumTypes,
	message_types: messageTypes,
	displayed_support_ids: displayedSupportIds
});
